import { css, SerializedStyles } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  open: boolean
  hideTopArrow?: boolean
  _css?: SerializedStyles
  dataTestId?: string
  children: React.ReactNode
}

export const OptionDropdown: React.FC<Props> = ({
  open,
  children,
  hideTopArrow,
  _css,
  dataTestId,
}) => (
  <ul
    data-test-id={dataTestId}
    className={open ? 'option-dropdown is-opening' : 'option-dropdown'}
    css={css`
      margin-top: 7.5px;
      visibility: ${open ? `visible` : `hidden`};
      color: ${colors.text};
      background: ${colors.white00};
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      opacity: ${open ? `1` : `0`};
      padding: 5px 0;
      position: absolute;
      list-style: none;
      min-width: 220px;
      white-space: nowrap;
      transition: 0.2s;
      z-index: 2;
      ${hideTopArrow ||
      `&:before {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        border-bottom-color: #d9d9d9;
        content: ' ';
        height: 0;
        position: absolute;
        width: 0;
        top: -10px;
        left: 13%;
      }
      &:after {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        top: -9px;
        content: ' ';
        height: 0;
        position: absolute;
        width: 0;
        left: 13%;
      }`}
      ${_css}
    `}
  >
    {children}
  </ul>
)
